import Home from '../pages/home/page';
import About from '../pages/about/page';
import Apply from '../pages/apply/page';
import Privacy from '../pages/privacy/page';
import Terms from '../pages/terms/page';
import Articles from '../pages/articles/page';     // 添加 Articles 页面导入
import Jiaju from '../pages/articles/jiaju/page'; // 添加 Jiaju 页面导入
import NotFound from '../pages/NotFound';
import type { JSX } from "react";

const routes: ({ path: string; element: JSX.Element })[] = [
    {
        path: '/',
        element: <Home/>
    },
    {
        path: '/about',
        element: <About/>
    },
    {
        path: '/apply',
        element: <Apply/>
    },
    {
        path: '/privacy',
        element: <Privacy/>
    },
    {
        path: '/terms',
        element: <Terms/>
    },
    {
        path: '*',
        element: <NotFound/>
    },
    {
        path: '/articles',
        element: <Articles/>  // 添加这行
    },
    {
        path: '/articles/jiaju',
        element: <Jiaju />
    },
];

export default routes;
